import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button as AntdButton, Flex, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../../../../../components/common/Icon';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardHead, LeftPanelContainer, PanelSearch, } from '../../../editor.style';
import AlphabetList from '../../../../../components/common/AlphabetList';
import { deleteMap3DObjectAction, getMap3DObjectsAction } from '../../../../../store/mapObjectSlice';
const ThreeDObjectListPanel = ({ isOpen, onBack }) => {
    const dispatch = useDispatch();
    const [searchKey, setSearchKey] = useState();
    const mapObjects = useSelector((state) => state?.mapObject?.getMapObjects?.response?.content);
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    return (_jsx(_Fragment, { children: _jsx(LeftPanel, { style: {
                width: '320px',
            }, isOpen: isOpen, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsxs(LeftPanelCardHead, { children: [_jsxs(Flex, { align: "center", style: { marginBottom: 10 }, children: [_jsx("h3", { children: "3D Objects" }), _jsx(AntdButton, { color: "primary", variant: "text", icon: _jsx(Icon, { icon: "plus-circle" }), onClick: () => {
                                                onBack();
                                            } })] }), _jsx(Flex, { align: "center", gap: 12, children: _jsx(PanelSearch, { placeholder: "Search Locations", variant: "filled", allowClear: true, prefix: _jsx(Icon, { icon: "search-md", size: 16 }), onChange: (e) => {
                                            setSearchKey(e.target.value);
                                        } }) })] }), _jsx(LeftPanelCardBody, { children: _jsx(AlphabetList, { hideCheckbox: true, searchKey: searchKey, onDelete: async (id) => {
                                    if (siteId) {
                                        try {
                                            await dispatch(deleteMap3DObjectAction({ siteId: siteId, mapObjectId: id }));
                                            await dispatch(getMap3DObjectsAction(siteId));
                                        }
                                        catch (error) {
                                            message.error('Something went wrong');
                                        }
                                    }
                                }, data: (mapObjects || [])?.map((it) => ({
                                    name: it.name,
                                    id: it.id,
                                })) }) })] }) }) }) }));
};
export default React.memo(ThreeDObjectListPanel);
